import { InputNumberLocalized, InputNumberLocalizedProps } from '@components'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { useGetZervantDocumentSettings } from '@features/invoicingSettings/hooks/useGetZervantDocumentSettings'

import { useInvoiceEditorForm } from '../../../../../../contexts/invoiceEditorFormContext'
import { useInvoiceEditorDocumentType } from '../../../../../../hooks/useInvoiceEditorDocumentType'

type CurrencyInputProps = InputNumberLocalizedProps

export const CurrencyInput = ({ readOnly = false, ...inputProps }: CurrencyInputProps) => {
  const { invoiceEditorForm } = useInvoiceEditorForm()
  const { watch } = invoiceEditorForm
  const { isCreditNote } = useInvoiceEditorDocumentType()
  const { getInvoiceLocale } = useGetZervantDocumentSettings(InvoiceDocumentType.Invoice)

  const locale = getInvoiceLocale()

  const minNumber = isCreditNote ? undefined : 0

  const currency = watch('currency')

  return (
    <InputNumberLocalized
      {...inputProps}
      bordered={!readOnly}
      locale={locale}
      min={inputProps.min ?? minNumber}
      readOnly={readOnly}
      suffix={currency}
    />
  )
}
